import { createStore } from 'vuex'

export default createStore({
  state: {
    margin_bottom_pc: '',
    margin_bottom_mobile: '',
    margin_bottom_pad: '',
    set_emoticon_flag: false,
    dialoge_initialisation: false,
  },
  getters: {
    get_language() {
      localStorage.getItem("language")
    }
  },
  mutations: {
    set_language(state, new_language) {
      localStorage.setItem("language",new_language)
    },
    set_margin_bottom_pc(state, new_margin_bottom_pc) {
      state.margin_bottom_pc=new_margin_bottom_pc;
    },
    set_margin_bottom_mobile(state, new_margin_bottom_mobile) {
      state.margin_bottom_mobile=new_margin_bottom_mobile;
    },
    set_margin_bottom_pad(state, new_margin_bottom_pad) {
      state.margin_bottom_pad=new_margin_bottom_pad;
    },
    set_set_emoticon_flag(state, new_set_emoticon_flag) {
      state.set_emoticon_flag=new_set_emoticon_flag;
    },
    set_dialoge_initialisation(state, new_dialoge_initialisation) {
      state.dialoge_initialisation=new_dialoge_initialisation;
    }
  },
  actions: {
  },
  modules: {
  }
})
